import { LinkButton } from "@/components/ui/link-button";
import ChatSvgIcon from "@/shared/icons/ChatSvgIcon";
import { useTranslations } from "next-intl";
import { HStack, Span, useBreakpointValue, VStack } from "@chakra-ui/react";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { BaseDialog } from "../ui/dialog/BaseDialog";
import WhatsappSvgIcon from "@/shared/icons/social/WhatsappSvgIcon";
import PhoneSvgIcon from "@/shared/icons/PhoneSvgIcon";

const PAGE_PATTERNS = [
  { key: 'product', regex: /^\/(ru|en|kz)\/shop\/(?!giftboxes\/)(?!lookbook\/)[^/]+\/[^/]+$/ },
  { key: 'checkout', regex: /^\/(ru|en|kz)\/checkout/ },
  { key: 'success', regex: /^\/(ru|en|kz)\/profile\/orders\/\d+\/pay\/success$/ },
];

const PAGE_OFFSETS: Record<'product' | 'success' | 'default', { base: string; md: string }> = {
  product: { base: "128px", md: "80px" },
  success: { base: "80px", md: "80px" },
  default: { base: "0px", md: "80px" },
};

const HelpWidget = () => {
  const isMobile = useBreakpointValue({
    base: true, md: false
  });
  const [showModal, setShowModal] = useState<boolean>(false);

  useEffect(() => {
    if (!isMobile) {
      setShowModal(false);
    }
  }, [isMobile]);

  const t = useTranslations();
  const pathname = usePathname();

  const pageMatches = PAGE_PATTERNS.reduce((acc: Record<string, boolean>, pattern) => {
    acc[pattern.key] = pattern.regex.test(pathname);
    return acc;
  }, {} as Record<string, boolean>);

  const currentOffset = (Object.keys(pageMatches).find(key => pageMatches[key]) as 'product' | 'success' | 'default') || "default";

  return (
    <>
      <LinkButton
        position="fixed"
        zIndex={1000}
        left={{ base: 'calc(100% - 66px)', md: 'calc(100% - 40px)' }}
        display={pageMatches.checkout ? 'none' : 'inline-flex'}
        bottom={PAGE_OFFSETS[currentOffset]}
        transform={{ base: '', md: "rotate(-90deg) translateY(100%)" }}
        transformOrigin="left bottom"
        rounded={0}
        minWidth="56px"
        height={{ base: '56px', md: '40px' }}
        bg={'#000000'}
        p={{ base: "4px", md: "16px" }}
        mb={{ base: '12px', md: "0" }}
        mr={{ base: '10px', md: "0" }}
        href="https://wa.me/77082405949"
        onClick={(e) => {
          if (isMobile) {
            e.preventDefault();
            setShowModal(true);
          }
        }}
        target="_blank"
      >
        <ChatSvgIcon w="22px" h="22px" />
        <Span ml={'4px'} textStyle={'regular16'} display={{ base: 'none', md: 'inline-block' }}>
          {t("help_widget_text")}
        </Span>
      </LinkButton>
      <BaseDialog
        open={showModal}
        onOpenChange={open => setShowModal(open)}
        title={t('widget_modal_text')}
        footer={
          <VStack w='100%'>
            <LinkButton
              w='100%'
              href="https://wa.me/77082405949"
              color="text.primary"
              textStyle={'bold14'}
              variant={'qr_secondary'}
            >
              <HStack gap='8px' alignItems={'center'} justify={'center'}>
                <WhatsappSvgIcon w='24px' h='24px' />
                {t('widget_modal_whatsapp')}
              </HStack>
            </LinkButton>
            <LinkButton
              w='100%'
              href="tel:+77015722440"
              color="text.primary"
              textStyle={'bold14'}
              variant={'qr_secondary'}
            >
              <HStack textStyle={'bold14'} gap='8px' alignItems={'center'} justify={'center'}>
                <PhoneSvgIcon w='24px' h='24px' />
                {t('widget_modal_call_phone')}
              </HStack>
            </LinkButton>
          </VStack>
        }
      />
    </>
  );
};

export default HelpWidget;